import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Receipt } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Switch } from './ui/switch';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SnapEtBillingEncountersCard = () => {
  const { user } = useAuth();
  const canEdit = user?.role === 'system_admin';
  const [states, setStates] = useState(null);
  const [saving, setSaving] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings/snap-et-billing-encounters`)
      .then((r) => setStates(r.data.states || []))
      .catch(() => { setStates([]); toast.error('Failed to load SNAP E&T Billing Encounters'); });
  }, []);

  const toggle = async (state, enabled) => {
    setSaving(state);
    try {
      await axios.put(`${API}/settings/snap-et-billing-encounters/${state}`, { enabled });
      setStates((prev) => prev.map((s) => (s.state === state ? { ...s, enabled } : s)));
      toast.success(`${state} billing encounters ${enabled ? 'on' : 'off'}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to update setting');
    } finally {
      setSaving(null);
    }
  };

  return (
    <Card className="card-shadow" data-testid="snap-et-billing-encounters-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><Receipt className="w-5 h-5" />SNAP E&T Billing Encounters</CardTitle>
        <CardDescription>
          When a state is on, the Billing CSV on the Master Enrollment Metrics report leaves out Second Enrollment rows for that state, so each participant appears once with their First Enrollment.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {!states ? (
          <Loader2 className="w-5 h-5 animate-spin" />
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {states.map((s) => (
              <label key={s.state} className="flex items-center justify-between p-3 border rounded-lg" data-testid={`billing-encounter-row-${s.state}`}>
                <span className="font-medium text-sm">{s.state}</span>
                <Switch
                  checked={s.enabled}
                  disabled={!canEdit || saving === s.state}
                  onCheckedChange={(v) => toggle(s.state, v)}
                  data-testid={`billing-encounter-toggle-${s.state}`}
                />
              </label>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
